import type { FC } from 'react';

import type { Company } from './company';

type WidgetItemConfig = {
  component: FC<{ company: Company }>;
  name: string;
};

export type WidgetItemId =
  | 'firmographics'
  | 'signals'
  | 'salesforceActivity'
  | 'trafficVisits'
  | 'trafficShare'
  | 'technologies'
  | 'engagement'
  | 'adNetworks'
  | 'ecommerce';

export type WidgetConfig = Record<WidgetItemId, WidgetItemConfig>;

export type WidgetItem = {
  id: WidgetItemId;
  isChecked: boolean;
};

export const widgetItemIds: WidgetItemId[] = [
  'firmographics',
  'signals',
  'salesforceActivity',
  'trafficVisits',
  'trafficShare',
  'technologies',
  'engagement',
  'adNetworks',
  'ecommerce',
];
